module.exports = __webpack_public_path__ + "static/img/header_text.166e0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activityforecast2024/header_text.png
// module id = Hr6h
// module chunks = 0